
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/reference/authentication",
      function () {
        return require("private-next-pages/core-exchange/docs/reference/authentication.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/reference/authentication"])
      });
    }
  